export default "/check.6eca02f75800a6bb5aa664356063a84c.svg";